<template>
	<div>
		<LeadLockup lead="Shipping Information">
			<p v-if="isDigitalProduct">
				For future purchases, we recommend adding a shipping address.
			</p>
		</LeadLockup>

		<AddressForm
			:address="shippingAddress"
			:errors="showFormErrors ? shippingAddressErrors : []"
			:postal-code-mismatch-error="shippingPostalCodeMismatchError"
			@change="setShippingAddress"
			@postalCodeUpdated="setShippingPostalCodeMismatchError(false)"
		/>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import LeadLockup from '@component/user-backend/Checkout/V4/LeadLockup.vue';
import AddressForm from '@component/user-backend/Checkout/V4/forms/AddressForm.vue';

export default {
	components: {
		LeadLockup,
		AddressForm,
	},

	computed: {
		...mapState('checkout', [
			'shippingAddress',
			'showFormErrors',
			'shippingPostalCodeMismatchError',
		]),
		...mapGetters('checkout', [
			'shippingAddressErrors',
			'isDigitalProduct',
		]),
	},

	methods: {
		...mapMutations('checkout', [
			'setShippingAddress',
			'setShippingPostalCodeMismatchError',
		]),
	},
};
</script>
